<template>
  <div style="width: 100%; height: 100%">

    <div class="centered-child" style="padding-bottom: 16px">
      <div style="width: 100%; max-width: 200px">
      <img src="/static/team.svg" width="100%">
      </div>
    </div>

    <h2>Your file needs a personalised help.</h2>
    <p>We advise you to contact our experts for a personnalised procedure.</p>

    <p>
    You can <router-link to="/">restart</router-link> another procedure
    or contact us by email <a @click="onClickContact()">contact-visa@getmyvisatofrance.com</a> to have an appointment with our experts 
    </p>

    <div class="centered-child" style="margin-top: 0px; align-items: center; flex-direction: column">
      <md-button class="md-raised md-primary large-button" @click="onClickContact()">Contact us</md-button>
    </div>
 

  </div>
</template>


<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    ServiceAccess.instance.track(this.$route.params.sessionId, 'screen-ko', {kind: 'Avocat', path: this.$route.path})
  },
  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },

  methods: {
    prevScreen: function () {
      this.$router.back()
    },
    
    onClickContact: function () {
      global.LC_API.open_chat_window()
    }

  }
}
</script>



// WEBPACK FOOTER //
// ScreenAvocat.vue?59c75161